var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item-group',{staticClass:"d-flex flex-column",attrs:{"multiple":_vm.multiple},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('draggable',_vm._b({model:{value:(_vm.dragFields),callback:function ($$v) {_vm.dragFields=$$v},expression:"dragFields"}},'draggable',_vm.draggableProps,false),[_vm._l((_vm.dragFields),function(item,index){return [_vm._t("default",null,null,{
          item: item,
          index: index,
          key: _vm.getItemKey(item),
          isActive: _vm.isPanelOpen(item),
        })]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }